import { render } from "./InputTextArea.vue?vue&type=template&id=e354ef84"
import script from "./InputTextArea.vue?vue&type=script&lang=js"
export * from "./InputTextArea.vue?vue&type=script&lang=js"

import "./InputTextArea.vue?vue&type=style&index=0&id=e354ef84&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__